/* ============================================================
   AOBA theme behaviors — generated from aoba-homepage-v3.html
   v2: size calculator now data-driven (brand chart, in/cm)
   ============================================================ */
(function () {
  'use strict';

  function initNav(root) {
    var nav = root.querySelector('.ao-nav');
    if (nav && !nav.dataset.aoInit) {
      nav.dataset.aoInit = '1';
      window.addEventListener('scroll', function () {
        nav.classList.toggle('scrolled', window.scrollY > 20);
      }, { passive: true });
    }

    var burger = root.querySelector('[data-ao-burger]');
    var drawer = root.querySelector('[data-ao-drawer]');
    var overlay = root.querySelector('[data-ao-overlay]');
    var closeBtn = root.querySelector('[data-ao-drawer-close]');
    if (!burger || !drawer || burger.dataset.aoInit) return;
    burger.dataset.aoInit = '1';

    function openDrawer() {
      drawer.classList.add('open');
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  function initReveal(root) {
    if (!('IntersectionObserver' in window)) {
      root.querySelectorAll('.ao-reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    root.querySelectorAll('.ao-reveal:not(.in)').forEach(function (el) {
      if (el.dataset.aoObserved) return;
      el.dataset.aoObserved = '1';
      io.observe(el);
    });
  }

  /* Generic snap carousel: reviews + product carousels. */
  function initCarousels(root) {
    root.querySelectorAll('[data-ao-carousel]').forEach(function (wrap) {
      if (wrap.dataset.aoInit) return;
      wrap.dataset.aoInit = '1';
      var track = wrap.querySelector('[data-ao-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.children);
      var prevBtn = wrap.querySelector('[data-ao-prev]');
      var nextBtn = wrap.querySelector('[data-ao-next]');
      var dotsWrap = wrap.querySelector('[data-ao-dots]');
      var total = cards.length;
      var current = 0;
      var dots = [];

      if (dotsWrap) {
        cards.forEach(function (_, i) {
          var d = document.createElement('button');
          d.className = 'rev-dot' + (i === 0 ? ' active' : '');
          d.setAttribute('aria-label', 'Item ' + (i + 1));
          d.setAttribute('role', 'tab');
          d.addEventListener('click', function () { scrollToCard(i); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }

      function setActive(i) {
        current = i;
        dots.forEach(function (d, j) { d.classList.toggle('active', j === current); });
      }
      function scrollToCard(idx) {
        var i = (idx + total) % total;
        var card = cards[i];
        var px = parseInt(getComputedStyle(track).paddingLeft || 0, 10) || 0;
        track.scrollTo({ left: card.offsetLeft - px, behavior: 'smooth' });
        setActive(i);
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToCard(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToCard(current + 1); });

      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var px = parseInt(getComputedStyle(track).paddingLeft || 0, 10) || 0;
          var closest = 0, min = Infinity;
          cards.forEach(function (c, i) {
            var diff = Math.abs(c.offsetLeft - px - track.scrollLeft);
            if (diff < min) { min = diff; closest = i; }
          });
          if (closest !== current) setActive(closest);
        }, 80);
      }, { passive: true });
    });
  }

  /* Size calculator — data-driven from embedded JSON chart (body
     measurements, "to fit"). Default unit inches; cm toggle. Uses
     midpoint tolerance (+1in) between 2in size steps. */
  function initSizeCalc(root) {
    root.querySelectorAll('[data-ao-sizecalc]').forEach(function (sc) {
      if (sc.dataset.aoInit) return;
      sc.dataset.aoInit = '1';
      var dataEl = sc.querySelector('[data-sc-chart-data]');
      if (!dataEl) return;
      var chart;
      try { chart = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var unit = 'in';
      var $ = function (sel) { return sc.querySelector(sel); };
      var $$ = function (sel) { return Array.prototype.slice.call(sc.querySelectorAll(sel)); };
      var ph = { in: { bust: '36', waist: '30', hips: '38' }, cm: { bust: '91', waist: '76', hips: '96' } };

      function setUnit(u) {
        unit = u;
        $$('[data-sc-unit]').forEach(function (b) {
          var on = b.dataset.scUnit === u;
          b.classList.toggle('on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        $$('[data-sc-cell]').forEach(function (td) {
          var vIn = parseFloat(td.dataset.scCell);
          td.textContent = (u === 'cm') ? Math.round(vIn * 2.54) : vIn;
        });
        $$('[data-sc-th-unit]').forEach(function (s) { s.textContent = u; });
        var note = $('[data-sc-unit-note]');
        if (note) note.textContent = (u === 'cm') ? 'All measurements in centimetres (cm)' : 'All measurements in inches';
        ['bust', 'waist', 'hips'].forEach(function (k) {
          var inp = $('[data-sc-' + k + ']');
          if (inp) inp.placeholder = ph[u][k];
        });
      }
      $$('[data-sc-unit]').forEach(function (b) {
        b.addEventListener('click', function () { setUnit(this.dataset.scUnit); });
      });

      var btn = $('[data-sc-btn]');
      if (btn) btn.addEventListener('click', function () {
        var raw = {
          bust: parseFloat($('[data-sc-bust]').value),
          waist: parseFloat($('[data-sc-waist]').value),
          hips: parseFloat($('[data-sc-hips]').value)
        };
        var out = $('[data-sc-out]'), note = $('[data-sc-note]'), result = $('[data-sc-result]');
        var f = (unit === 'cm') ? 1 / 2.54 : 1;
        var bust = raw.bust * f, waist = raw.waist * f, hips = raw.hips * f;
        var valid = raw.bust && raw.waist && raw.hips &&
          bust >= 24 && bust <= 60 && waist >= 18 && waist <= 55 && hips >= 26 && hips <= 62;
        if (!valid) {
          out.textContent = '?';
          note.textContent = 'Please enter valid measurements for all three fields.';
          result.classList.add('show');
          return;
        }
        var rec = null, TOL = 1;
        for (var i = 0; i < chart.length; i++) {
          if (bust <= chart[i].bust + TOL && waist <= chart[i].waist + TOL && hips <= chart[i].hips + TOL) { rec = chart[i]; break; }
        }
        var beyond = !rec;
        if (beyond) rec = chart[chart.length - 1];
        out.textContent = rec.size;
        note.textContent = beyond
          ? 'Size ' + rec.size + ' is our closest fit for your measurements. For personalised fit help, WhatsApp us before ordering.'
          : 'This size fits your bust, waist & hips. Happy shopping!';
        result.classList.add('show');
        $$('.sc-chart tr').forEach(function (r) { r.classList.remove('hl'); });
        var hl = sc.querySelector('[data-sc-row="' + rec.size + '"]');
        if (hl) hl.classList.add('hl');
      });

      var toggle = $('[data-sc-chart-toggle]');
      if (toggle) toggle.addEventListener('click', function () {
        var c = $('[data-sc-chart]');
        var open = c.classList.toggle('show');
        this.textContent = open ? 'Hide size chart ↑' : 'View full size chart ↓';
      });

      setUnit('in');
    });
  }

  function initAll(root) {
    root = root || document;
    initNav(root);
    initReveal(root);
    initCarousels(root);
    initSizeCalc(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
